/**
 * @module OutputStream
 * @author nuintun
 * @author Kazuhiko Arase
 */
var OutputStream = /*#__PURE__*/ (function () {
    function OutputStream() {
    }
    OutputStream.prototype.writeBytes = function (bytes) {
        var length = bytes.length;
        for (var i = 0; i < length; i++) {
            this.writeByte(bytes[i]);
        }
    };
    OutputStream.prototype.flush = function () {
        // The flush method
    };
    OutputStream.prototype.close = function () {
        this.flush();
    };
    return OutputStream;
}());

export { OutputStream };
